/* eslint-disable no-restricted-globals */
/* eslint-disable no-plusplus */
import React, {useEffect, useState} from 'react'
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import {Box} from "@mui/material";
import Slide from '@mui/material/Slide';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
// import BatchCheckbox from '../../components/BatchCheckbox';
import { postRequest } from '../../utils/NetworkHandler';
import Batch from '../../components/Batch';

const Transition = React.forwardRef((props, ref) => <Slide direction="left" ref={ref} {...props} />);


export default function AddMadrasaDialog(props) {
    const [maxWidth, setMaxWidth] = React.useState('xs');
    const [fullWidth, setFullWidth] = React.useState(true);
    const [loading, setLoading] = useState(false);

    const [fullName, setFullName] = useState("");
    const [desc, setDescName]=useState("");
    const [fee, setFee] = useState("");
    const [address, setAddress] = useState("");
    const [SampleData, setSampleData] = useState([{ service: "" }]);
    const [fullNameHelper, setFullNameHelper] = useState("");
    const [descHelper, setDescHelper]=useState("");
    const [feeHelper, setFeeHelper] = useState("");
    const [addressHelper, setAddressHelper] = useState("");
  

    const {batches} = props;

    const [batchData, setBatchData] = useState([]);

    function createBatchdata(id, checked, batch){
      return {id, checked, batch};
    }
    

    useEffect( () => {
     if(batches !== null && batches !== undefined && batches.length > 0){
      const batchArr = [];
      for(let i =0; i< batches.length; i++){
        const batch = batches[i];
        const data = createBatchdata(batch.id, true, batch.batch);
        batchArr.push(data);
      }
      setBatchData(batchArr);
     }
    }, [batches,] );

    const requiredText = "This field is required";

    const handleBatchCheckChange = (index, event) => {
      const data = [...batchData];
      const editRow = data[index];
      editRow.checked = event.target.checked;
      data[index] = editRow;
      setBatchData(data);

    }


    const saveAccount = () => {
        setLoading(true);
        let formValidated = true;
       
        if(fullName === ""){
            formValidated = false;
            setFullNameHelper(requiredText);
        }
        if(desc === ""){
          formValidated = false;
          setDescHelper(requiredText);
      }
        if(address === ""){
          formValidated = false;
          setAddressHelper(requiredText);
        }
        
       
        if(isNaN(fee) || fee === "" ){
          formValidated = false;
          setFeeHelper("Please eneter a valid number");
        }
        
        // let checked = false;
        // for(let i =0; i< batchData.length; i++){
        //   const batch = batchData[i];
        //   if(batch.checked){
        //     checked = true;
        //   }
        // }

        // if (!checked){
        //   formValidated = false;
        //   alert("Please select at least one batch");
        // }

    
        if(formValidated){
            const data = {'madrasa_name': fullName, 'descripton':desc, 'fee': fee, 'address': address, 'batches': SampleData}
            postRequest("/landing/api/ummah/add-madrasa", data, onSuccess, onError, true);
        }
        else{
            setLoading(false);
        }

    }

    const onSuccess = (response)=> {
        setLoading(false);

        const {data} = response;
        if(data.status){
          
            setFullName("");
            setAddress("");
            setFee("");
            setDescName("");
            handleClose();
            props.onRefresh();
            setSampleData("");
            setDescName("");
        }
    }

    const onError = (error) => {
        setLoading(false);
        alert(error.toString());
    }

    const handleClose = () => {
      
        setFullNameHelper("");
        setFeeHelper("");
        setAddressHelper("");
        props.handleClose();

    }

  return (
    <div>
      
      <Dialog open={props.open} onClose={handleClose}
      maxWidth={maxWidth}
      fullWidth={fullWidth}
        TransitionComponent={Transition}
      >
        <DialogTitle>Add a madrasa</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Please fill in this form to proceed.
          </DialogContentText>
         <Box sx={{display:"flex", gap:'10px'}}  />

         <Box sx={{display:"flex", gap:'10px'}} >

         <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Madrasa Name"
            type="text"
            error={fullNameHelper !== "" }
            helperText={fullNameHelper}
            value={fullName}
            onChange={(e) => setFullName(e.target.value)}
            variant="standard"
          />



<TextField
            autoFocus
            margin="dense"
            id="fee"
            label="Madrasa Fee"
            type="number"
            error={feeHelper !== "" }
            helperText={feeHelper}
            value={fee}
            onChange={(e) => setFee(e.target.value)}
            variant="standard"
          />
         
        </Box>

        <Box sx={{display:"flex", gap:'10px'}} >
 <TextField
            autoFocus
            margin="dense"
            id="addresss"
            label="Address"
            type="text"
            multiline
            error={addressHelper !== "" }
            helperText={addressHelper}
            value={address}
          rows={2}

            onChange={(e) => setAddress(e.target.value)}
            variant="standard"
          />
           <TextField
            rows={2}
            multiline
            autoFocus
            margin="dense"
            id="desc"
            label="Description"
            type="text"
            error={descHelper !== "" }
            helperText={descHelper}
            value={desc}
            onChange={(e) => setDescName(e.target.value)}
            variant="standard"
          />
        </Box>
       

        <Batch setSampleData={setSampleData}/>

     

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button disabled={loading}  onClick={() => saveAccount() }>Save</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}


